import {Component, inject, OnInit} from '@angular/core';
import { isPlatformBrowser } from "@angular/common";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {CombinedCryptoData} from "../../../../../core/models/market.model";
import {MarketDataService} from "../../services/market-data.service";

@Component({
  selector: 'bit-main',
  templateUrl: './heatmap-main.component.html',
  styleUrls: ['./heatmap-main.component.scss'],
})
export class HeatmapMainComponent implements OnInit {
  baseMarket: 'IRT' | 'USDT' = "IRT"
  market$!: Observable<CombinedCryptoData[] | undefined>
  newMarketData: Observable<CombinedCryptoData[]> = this.market$ as Observable<CombinedCryptoData[]>;

  constructor(private marketDataService: MarketDataService) {}

  ngOnInit(): void {
    this.getMarket();
  }

  getMarket(treemapType: 'IRT' | 'USDT' = 'IRT'): void {
    this.baseMarket = treemapType
    this.market$ = this.marketDataService.getCombinedMarketCurrencyData(treemapType).pipe(
      map((marketResponse: CombinedCryptoData[]) => {
        // TODO: after websocket I should implement this method.
        /*
        if (marketResponse && isPlatformBrowser(this.platformId)) {
          this.newMarketData = this.market.updateMarketData(marketResponse);
        }
         */
        return marketResponse;
      })
    )
  }

}
